// extracted by mini-css-extract-plugin
export default {"page":"mj-z","cartModal":"nj-z","checkout":"oj-z","placeholder":"pj-z","account":"qj-z"};